<template>
    <div>
        <div
            v-for="tab in tabs"
            :key="tab.value"
            class="summary-tab"
            :class="{ active: tab.value === value }"
            @click="$emit('input', tab.value)"
        >
            <span class="summary-tab__label">{{ tab.text }}</span>

            <span v-if="tab.count || tab.count === 0" class="summary-tab__number ml-2">{{ tab.count }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SummaryTabsButtons',
    props: {
        value: String,
        tabs: Array,
    },
}
</script>

<style lang="scss" scoped>
.summary-tab {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 52px;
    margin-right: 12px;
    margin-bottom: 20px;
    padding: 0 30px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid transparent;
    border-radius: $border-radius;
    color: $color-white;
    line-height: 1;
    transition: all 0.3 ease;
    cursor: pointer;

    .summary-tab__number {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        min-width: 24px;
        min-height: 24px;
        background: $color-gold;
        color: $color-white;
        border-radius: 12px;
        padding: 2px 4px;
        font-size: rem(16px);
        font-weight: 600;
    }

    .summary-tab__label {
        font-size: rem(16px);
    }

    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }

    &.active {
        background: transparent;
        border-color: $color-secondary;
        color: $color-secondary;
    }
}
</style>
